<template>
    <div
        id="topol-editor"
        style="position: absolute; width: 100%; height: 100%"
    ></div>
</template>

<script lang="ts" setup>
import { useScriptTag } from "@vueuse/core";

useScriptTag(
    "https://d5aoblv5p04cg.cloudfront.net/develop/loader/build.js",
    // on script tag loaded.
    (_el: HTMLScriptElement) => {
        const TOPOL_OPTIONS = {
            id: "#topol-editor",
            authorize: {
                apiKey: "vF9mP5fZaCD15WgrhGoj8pYJDodoq6xCNXsWKGnhloMbUpxIeh740j5L9cgt",
                userId: "test",
            },
            defaultTemplateSettings: {
                emailBackgroundColor: "#ffffff",
            },
            hideSettingsTab: true,
            language: "cs",
            light: true,
            title: "",

            mergeTags: [
                {
                    name: "Merge tags", // Group name
                    items: [
                        {
                            value: "{{first_name}}", // Text to be inserted
                            text: "First name", // Shown text in the menu
                            label: "Customer's first name", // Shown description title in the menu
                        },
                        {
                            value: "{{event_name}}",
                            text: "Event Type name",
                            label: "Name of Event Type user books",
                        },
                        {
                            value: "{{duration}}",
                            text: "Duration",
                            label: "Duration of the meeting",
                        },
                    ],
                },
            ],

            smartMergeTags: {
                enabled: true,
                syntax: {
                    start: "{{",
                    end: "}}",
                },
            },

            theme: {
                preset: "light",
                canvasColor: "#ffffff",
                colors: {
                    "900": "#FCFCFD", // Lighter than #F7F7F8
                    "800": "#F9F9FA", // Lighter than #F1F1F2
                    "700": "#F6F6F7", // Lighter than #EBEBEC
                    "600": "#F1F1F2", // Lighter than #DFDFE0
                    "500": "#ECECED", // Lighter than #D7D8D9
                    "400": "#E3E3E5", // Lighter than #C9CACB
                    "300": "#D2D3D4", // Lighter than #A4A5A7
                    "200": "#51525c", // Lighter than #8D8F92
                    "100": "#9FA1A4", // Lighter than #727477
                    "50": "#787A7C", // Lighter than #4B4C4E
                    "10": "#000000",
                    white: "#ffffff",
                    primary: "#7f56d9",
                    "primary-light": "#B4A0FF",
                    "primary-light-2": "#DFD9FF",
                    secondary: "#11CFC4",
                    "secondary-light": "#00E5D8",
                    "secondary-light-2": "#CEFAF8",
                    error: "#C4261A",
                    "error-light": "#E32F22",
                    success: "#11BA5C",
                    "success-light": "#0CDB68",
                    active: "#9D82FF",
                    "active-2": "#0FCE56",
                    "active-3": "#FF9900",
                },
            },
            mainMenuAlign: "right",
            contentBlocks: {
                html: {
                    hidden: true,
                },
                product: {
                    hidden: true,
                },
                button: {
                    hidden: true,
                },
                gif: {
                    hidden: true,
                },
                social: {
                    hidden: true,
                },
                video: {
                    hidden: true,
                },
            },
            removeTopBar: true,
            premadeBlocks: false,
            callbacks: {
                onSave: function (_json: any, _html: any) {
                    //work with JSON and HTML
                },
            },
        };

        // @ts-expect-error
        window.TopolPlugin.init(TOPOL_OPTIONS);
    },
);
</script>
